import { FileTree } from "../types/filetree.js";
import { filesToTree } from "./filetree.js";
import { FileIgnoreRules, readBidsIgnore } from "./ignore.js";
/**
 * Browser implement of BIDSFile wrapping native File/FileList types
 */ export class BIDSFileBrowser {
  #ignore;
  #file;
  name;
  path;
  parent;
  viewed = false;
  constructor(file, ignore, parent){
    this.#file = file;
    this.#ignore = ignore;
    this.name = file.name;
    const relativePath = this.#file.webkitRelativePath;
    const prefixLength = relativePath.indexOf('/');
    this.path = relativePath.substring(prefixLength);
    this.parent = parent ?? new FileTree('', '/', undefined);
  }
  get size() {
    return this.#file.size;
  }
  get stream() {
    return this.#file.stream();
  }
  get ignored() {
    return this.#ignore.test(this.path);
  }
  text() {
    return this.#file.text();
  }
  async readBytes(size, offset = 0) {
    return new Uint8Array(await this.#file.slice(offset, size).arrayBuffer());
  }
}
/**
 * Convert from FileList (created with webkitDirectory: true) to FileTree for validator use
 */ export async function fileListToTree(files) {
  const ignore = new FileIgnoreRules([]);
  const root = new FileTree('/', '/', undefined);
  const tree = filesToTree(files.map((f)=>new BIDSFileBrowser(f, ignore, root)), ignore);
  const bidsignore = tree.get('.bidsignore');
  if (bidsignore) {
    try {
      ignore.add(await readBidsIgnore(bidsignore));
    } catch (err) {
      console.log(`Failed to read '.bidsignore' file with the following error:\n${err}`);
    }
  }
  return tree;
}
//# sourceMappingURL=browser.js.map